module.exports = __webpack_public_path__ + "teqbahn-assets/media/innovation.dde4c47c.png";